
import { useEffect } from "react";

import "./Program.css";
import "../Home/Components/attributes/Attributes.css"

import Navbar from "../Navbar/Navbar";
import Footer from "../Home/Components/footer/Footer";

const PrimaryProgram = () => {

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "auto" });
    }, []);

    return (<>

        <Navbar />

        <div className="about-main">

            <div className="about-sec-1">

                <div className="about-s2-1">
                    <h1>The Primary Montessori Programme <br/> <span>(Ages 3 – 6 years)</span></h1>
                    <div>
                        <p style={{ fontWeight: "600", lineHeight: "30px", marginBottom: "50px", textAlign: "justify" }}><span style={{ background: "#ff8843a5", paddingLeft: "5px" }}>The Primary Montessori Programme</span> supports the child during a crucial period of conscious learning and self-construction. Building on the foundation laid in the toddler years, the child now seeks to develop independence, social awareness, and intellectual skills.</p>
                        <p style={{ fontWeight: "600", lineHeight: "30px", marginBottom: "50px", textAlign: "justify" }}><span style={{ background: "#ff8843a5", paddingLeft: "5px" }}>Three Year Cycle,</span> Montessori is a continuum of education that allows your child to build upon experiences each year.  Your child will stay in the Primary classroom for 3 years, including the traditional “kindergarten year” — when the seeds of learning come to fruition.</p>
                        <p style={{ fontWeight: "600", lineHeight: "30px", marginBottom: "50px", textAlign: "justify" }}><span style={{ background: "#ff8843a5", paddingLeft: "5px" }}>Reading and writing</span> come to life from sounds and symbols. An introduction to numbers and the decimal system turn into lessons on addition, subtraction, and even multiplication and division. Students learn about geometric figures and the political countries of our world. Your child will leave the program with a strong set of academic skills; but, far more importantly, with the attitude that learning is fun, exciting and boundless.</p>
                    </div>
                    <button className="start-btn" style={{ marginTop: "80px" }} onClick={() => window.open("https://api.whatsapp.com/send?phone=919246182801&text=" + encodeURIComponent("Hello, I want to enquire for admissions \uD83D\uDCDA"), "_blank")} >Enroll Now <i className="fa-solid fa-arrow-up"></i></button>
                </div>
                <div className="about-s2-2">
                    <div className="pi-primary">

                    </div>
                </div>

            </div>

        </div>

        <Footer />

    </>)

}

export default PrimaryProgram;